import type { StoreCategory, TemplateCategory, TemplateSubcategory } from "./api";

/**
 * A site a signed-out visitor finished choosing in the create wizard. It is
 * kept for this browser tab while they sign up or log in, then the wizard
 * creates it on their return (/app/onboarding?resume=1).
 */
export interface PendingSite {
  templateId: string;
  templateName: string | null;
  kind: "website" | "store";
  group: TemplateCategory | null;
  subcategory: TemplateSubcategory | null;
  category: StoreCategory | null;
  name: string;
  email: string;
  phone: string;
  description: string;
}

const KEY = "zirro.pendingSite";

/** Where the wizard sends people after they sign up or log in. */
export const RESUME_PATH = "/app/onboarding?resume=1";

export function savePendingSite(site: PendingSite): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(site));
  } catch {
    // Storage blocked (private mode): they will pick their design again.
  }
}

export function loadPendingSite(): PendingSite | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const site = JSON.parse(raw) as PendingSite;
    return typeof site?.templateId === "string" && typeof site.name === "string" ? site : null;
  } catch {
    return null;
  }
}

export function clearPendingSite(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}
